// frontend/src/StoreLocator/common.js — pure helpers shared by the tabs.
export const DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
export const DAY_NAMES = { mon: 'Monday', tue: 'Tuesday', wed: 'Wednesday', thu: 'Thursday', fri: 'Friday', sat: 'Saturday', sun: 'Sunday' };
export const TABS = [['locations', 'Locations'], ['special-hours', 'Special hours'], ['notices', 'Notifications'], ['tags', 'Tags'], ['stores', 'Stores & Publish']];
export const STYLES = { notice: ['Notice', 'can'], promo: ['Promo', 'ful'], info: ['Info', 'neu'] };

// '20:00' -> '8:00 PM'
export function clock(hhmm) {
  if (!hhmm) return '';
  const [h, m] = hhmm.split(':').map(Number);
  const ampm = h >= 12 ? 'PM' : 'AM';
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, '0')} ${ampm}`;
}

export function hoursText(day) {
  if (!day) return 'Closed';
  if (day.status === 'open') return `${clock(day.open)} – ${clock(day.close)}`;
  return day.status === '24h' ? 'Open 24 hours' : 'Closed';
}

export function scopeText(row) {
  if (row.scope === 'all') return 'All stores';
  if (row.scope === 'tag') return `Tag: ${row.tag || ''}`;
  return row.location_name || 'One store';
}

const fmt = (iso, opts) => new Date(`${String(iso).slice(0, 10)}T12:00:00`).toLocaleDateString('en-US', opts);

export function span(a, b) {
  if (!a) return '';
  const sameYear = String(a).slice(0, 4) === String(new Date().getFullYear());
  const o = sameYear ? { month: 'short', day: 'numeric' } : { month: 'short', day: 'numeric', year: 'numeric' };
  if (!b || b === a) return fmt(a, o);
  return `${fmt(a, { month: 'short', day: 'numeric' })} – ${fmt(b, o)}`;
}

export function openText(state) {
  if (!state) return '';
  if (state.open) return state.closes_at === 'midnight' ? 'Open now' : `Open now · closes ${state.closes_at}`;
  if (!state.opens_at) return 'Closed';
  return state.opens_on === 'today' ? `Closed · opens ${state.opens_at}` : `Closed · opens ${state.opens_on} ${state.opens_at}`;
}

export const emptyHours = () => Object.fromEntries(DAYS.map((d) => [d, { status: 'closed' }]));
